import { Link } from "react-router-dom";

const products = [
  { id: 1, name: "Olaplex No.3 Hair Perfector", price: "$30", category: "Treatment", image: "https://public.readdy.ai/ai/img_res/6af917c7605ca40082401090111a1366.jpg" },
  { id: 2, name: "Kérastase Elixir Ultime Oil", price: "$58", category: "Finishing", image: "https://readdy.ai/api/search-image?query=Kerastase%20hair%20oil%20serum%20bottle%20gold%20luxury%20hair%20care%20product%20white%20background%20editorial%20beauty%20product%20photography%20minimal&width=400&height=400&seq=shop2&orientation=squarish" },
  { id: 3, name: "Shu Uemura Essence Absolue", price: "$72", category: "Nourishing", image: "https://readdy.ai/api/search-image?query=Shu%20Uemura%20essence%20absolue%20nourishing%20hair%20oil%20luxury%20product%20white%20clean%20background%20beauty%20editorial%20photography&width=400&height=400&seq=shop3&orientation=squarish" },
  { id: 4, name: "GHD Gold Professional Styler", price: "$249", category: "Tools", image: "https://readdy.ai/api/search-image?query=GHD%20gold%20professional%20hair%20straightener%20flat%20iron%20luxury%20styling%20tool%20black%20gold%20white%20marble%20background%20editorial%20product%20photography&width=400&height=400&seq=shop4&orientation=squarish" },
];

export default function ShopSection() {
  return (
    <section className="w-full bg-white py-24 px-6" id="shop">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">Salon Retail</span>
          <h2 className="text-neutral-900 text-3xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
            Shop Our Favorites
          </h2>
          <p className="text-neutral-500 mt-4 text-sm max-w-md mx-auto leading-relaxed">
            The exact professional products our European stylists use and love — available for you to take home.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {products.map((p) => (
            <div key={p.id} className="group cursor-pointer">
              <div className="w-full h-64 bg-[#faf8f5] rounded-lg overflow-hidden mb-4">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <span className="text-[#C9A96E] text-xs font-bold tracking-widest uppercase">{p.category}</span>
              <h3 className="text-neutral-900 text-sm font-semibold mt-1 mb-2 leading-snug">{p.name}</h3>
              <div className="flex items-center justify-between">
                <span className="text-neutral-900 font-bold">{p.price}</span>
                <button className="w-8 h-8 flex items-center justify-center rounded-full bg-[#C9A96E]/10 hover:bg-[#C9A96E] hover:text-white text-[#C9A96E] transition-colors cursor-pointer">
                  <i className="ri-shopping-bag-line text-sm"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link to="/shop" className="inline-block border border-[#C9A96E] text-[#C9A96E] text-sm font-semibold tracking-widest uppercase px-12 py-4 rounded-sm hover:bg-[#C9A96E] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
            Shop All Products
          </Link>
        </div>
      </div>
    </section>
  );
}
